export const TabsBox = ({ children }) => (
  <div className="relative sm:-ml-8 flex max-sm:gap-2 sm:gap-[14px] overflow-auto no-scrollbar max-sm:after:min-w-4 sm:after:min-w-10 sm:after:-ml-5 after:h-[52px] after:sticky max-sm:after:right-0 sm:after:right-0 after:bg-gradient-to-r after:from-white/0 after:to-white max-sm:before:min-w-4 sm:before:min-w-10 max-sm:before:-mr-2 sm:before:-mr-5 before:h-[52px] before:sticky before:z-[1] before:left-0 before:bg-gradient-to-l before:from-white/0 before:to-white">
    {children}
  </div>
);
